import { BasicPanel } from "../panels/BasicPanel";

import DisplayObject = createjs.DisplayObject;

export class BasicScreen extends BasicPanel {
    constructor(disp: DisplayObject) {
        super(disp);
    }
}

